import { createSlice } from "@reduxjs/toolkit";
import { getNastionalPortel } from "../reduxApi/DmsReduxApi";

const nastionalPortelSlice = createSlice({
    name: 'nastionalPortel',
    initialState: {
    status: 'idel',
    nastionalPortel: [],
    },
    reducers: {
        
        deleteNastionalPortelAction: (state, action) => {
            action.NastionalPortelpayload.forEach((id) => {
                const index = state.attachments.findIndex((item) => item.nastionalPortel.ROWID === id);
                if (index !== -1) {
                    state.nastionalPortel.splice(index, 1);
                }
            });
        },     
        updateNastionalPortelAction: (state, action) => {
            // console.log("action", action.payload)
            const index = state.nastionalPortel.findIndex((item) => item.nastionalPortel.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.nastionalPortel.splice(index, 1, { nastionalPortel: action.payload })
            }
        },
        addNastionalPortelAction: (state, action) => {
            // console.log("Adding client:", action.payload); 
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID
            state.nastionalPortel.unshift({nastionalPortel:temp});
          }
    },
        extraReducers: (builder) => {
            builder
                .addCase(getNastionalPortel.pending, (state) => {
                    state.status = 'pending';
                })
                .addCase(getNastionalPortel.fulfilled, (state, action) => {
                    state.status = 'fulfilled';
                    state.nastionalPortel = action.payload.response; // Store DMS data
                })
                
        }
        
})
export const { deleteNastionalPortelAction, updateNastionalPortelAction, addNastionalPortelAction } = nastionalPortelSlice.actions
export default nastionalPortelSlice.reducer